import { LazyLoader, Modal } from '@bp/ui-components';
import { CourseSettingsForm } from 'components/Courses/forms/CourseSettingsForm';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';

type CourseSettingsModalProps = {
  isOpen: boolean;
  courseUuid: string;
  onClose: () => void;
};

export const CourseSettingsModal = ({ isOpen, courseUuid, onClose }: CourseSettingsModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal title={t('courses.coursesSettings')} isOpen={isOpen} loading={loading} onRequestClose={onClose} width='s'>
      <Suspense fallback={<LazyLoader embedded forceHeight='8vh' />}>
        <CourseSettingsForm onLoad={setLoading} onClose={onClose} courseUuid={courseUuid} />
      </Suspense>
    </Modal>
  );
};
